<template>
  <span :class="{ 'mr-2': tasks > 0 }" class="mx-1">
    <v-badge color="pink" :content="tasks" :value="tasks" overlap>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            :to="{
              name: dashboard,
              params: { coachId: coachId, lastUpdate: lastUpdated },
            }"
            v-bind="attrs"
            v-on="on"
            slot="activator"
            outlined
            pill
            medium
            active-class="green"
            class="pr-2"
          >
            <v-avatar left class="mr-1 font-weight-bold" :class="subscriptionCount > 0 ? 'green' : 'grey'">
              {{ subscriptionCount }}
            </v-avatar>
            <v-icon color="black">
              {{ icon }}
            </v-icon>
          </v-chip>
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
    </v-badge>
  </span>
</template>

<script>
export default {
  name: "HeaderPill",
  props: {
    coachId: {
      type: [Number, String],
      required: true,
    },
    lastUpdated: {
      type: [String, Object],
      required: false,
    },
    tooltip: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    subscriptionCount: {
      type: Number,
      default: 0,
    },
    dashboard: {
      type: String,
      required: true,
    },
    tasks: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.v-chip.v-chip--outlined {
  border-width: 2px;
}
</style>
